import LineShoppingBagIcon from 'LuxKit/Icons/line/LineShoppingBagIcon'
import { useMerchandiseOrdersByStatus } from 'hooks/useMerchandiseOrdersByStatus'
import type { ComponentProps } from 'react'
import { useMemo } from 'react'
import { useIntl } from 'react-intl'
import NavBarListItem from 'components/NavKit/NavBarListItem'
import { sum } from 'lib/array/arrayUtils'
import NavBarListItemIcon from '../NavBarListItemIcon'

type InheritedListItemProps = Pick<ComponentProps<typeof NavBarListItem>, 'onClick'>

function AccountMenuShopOrdersListItem(props: InheritedListItemProps) {
  const intl = useIntl()
  const { purchased } = useMerchandiseOrdersByStatus()

  const purchasedCopy = useMemo<string | undefined>(() => {
    const numberOfOrders = sum([purchased.length])
    if (numberOfOrders === 0) {
      return undefined
    }
    return intl.formatMessage(
      {
        id: 'SrjOFinxVwUoLOnNPfLC',
        defaultMessage: '{count, plural, one {# order} other {# orders}}',
        description: 'Pluralised count of shop orders displayed in the merchandise order history view',
      },
      { count: numberOfOrders },
    )
  }, [intl, purchased.length])

  return <NavBarListItem
    {...props}
    startIcon={<NavBarListItemIcon Icon={LineShoppingBagIcon} />}
    title={intl.formatMessage({
      id: 'IaV-Ah9bmkCswSDt9ZBI',
      defaultMessage: 'Shop Orders',
      description: 'Navigation item title for shop orders page in the navigation bar',
    })}
    titleFormat="titlecase"
    endTitle={purchasedCopy}
    to="/account/shop-orders"
  />
}

export default AccountMenuShopOrdersListItem
